// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n::-webkit-input-placeholder {\n  font-size: 0.8rem;\n}\n:-moz-placeholder {\n  font-size: 0.8rem;\n}\n::-moz-placeholder {\n  font-size: 0.8rem;\n}\n:-ms-input-placeholder {\n  font-size: 0.8rem;\n}\n", ""]);
// Exports
module.exports = exports;
